import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const getAll = "/users/all";
const addMember = "/users/addUser";
const bulkUpload = "/users/uploadInBulk";
const addUserFromWhatsapp = "/users/addUserFromWhatsapp";

export default {
  getAll(payload) {
    return Repository.post(`${getAll}`, payload);
  },
  addMember(payload) {
    return Repository.post(`${addMember}`, payload);
  },
  bulkUpload(payload) {
    return Repository.post(`${bulkUpload}`, payload);
  },
  addUserFromWhatsapp(payload) {
    return Repository.post(`${addUserFromWhatsapp}`, payload);
  },
};
